import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { TypedChanges } from '@platform-frontend/util';
import { Icon, IconName } from '../build';
import { IconRegistryService } from '../icon-registry.service';

/**
 * Styled with:
 * - --icon-width: width of the icon
 * - --icon-height: height of the icon
 * - --icon-color: color of the icon
 * - --icon-color-hover: color of the icon on hover
 */
@Component({
  selector: 'yat-icon',
  template: '',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent implements OnChanges {
  @Input()
  name: IconName | null | undefined;

  @Input()
  title: string | null | undefined;

  @Input()
  @HostBinding('class.multicolored')
  multiColored: boolean = false;

  constructor(private element: ElementRef, private iconRegistryService: IconRegistryService) {}

  ngOnChanges(changes: TypedChanges<IconComponent>): void {
    if (changes.name || changes.title) {
      this.updateDOM();
    }
  }

  private updateDOM(): void {
    if (!this.name) {
      this.element.nativeElement.innerHTML = '';
      return;
    }

    const icon = this.iconRegistryService.get(this.name);
    if (icon === null) {
      console.error(`No icon with the name "${this.name}" is registered.`);
      this.element.nativeElement.innerHTML = '';
      this.name = undefined;
      return;
    }

    this.element.nativeElement.innerHTML = this.buildSvgHtml(icon, this.title);
  }

  private buildSvgHtml(icon: Icon, title: string | null | undefined): string {
    let svg = icon.data;
    if (this.title) {
      svg = svg.replace(/(<svg[^>]*>)/, `$1<title>${title}</title>`);
    }
    if (!this.multiColored) {
      svg = svg.replace(/fill="#[0-9a-f]+"\/>/g, '/>');
    }
    return svg;
  }
}
